// src/pages/Success.jsx
import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/theme.css';
import '../styles/cosmic.css';
import '../styles/Success.css';

export default function Success() {
  const navigate = useNavigate();
  useEffect(() => {
    // Redirect immediately to dashboard with success param
    navigate('/dashboard?checkout=success', { replace: true });
  }, [navigate]);

  // Fallback UI (shouldn't be seen due to instant redirect)
  return (
    <main className="cosmic-bg">
      <div className="container center-card card">
        <h1>Welcome ✨</h1>
        <p>Your subscription was successful. Redirecting to your dashboard…</p>
        <Link className="btn" to="/dashboard">
          Go now
        </Link>
      </div>
    </main>
  );
}
